import React, { useState, useEffect } from 'react';

const LinkInputComponent = ({ onChange, links: initialLinks = [], error }) => {
  const [links, setLinks] = useState(initialLinks); // Start with initial links

  useEffect(() => {
    setLinks(initialLinks);
  }, [initialLinks]);

  const handleAddLink = () => {
    if (links.length >= 5) return; // Restrict to 5 entries
    setLinks([...links, '']);
  };

  const handleLinkChange = (index, value) => {
    const newLinks = [...links];
    newLinks[index] = value;
    setLinks(newLinks);
    onChange(newLinks.filter(link => link !== ''));
  };

  const handleRemoveLink = (index) => {
    const newLinks = links.filter((_, i) => i !== index);
    setLinks(newLinks);
    onChange(newLinks.filter(link => link !== ''));
  };
  

  return (
    <div className="space-y-4">
      {links.length > 0 && 
      links?.map((link, index) => (
        <div className='bg-gray-100 p-4 rounded-md' key={index}>
          <div className="flex items-center gap-2">
            <div className="relative flex-1">
              <input
                type="text"
                value={link}
                onChange={(e) => handleLinkChange(index, e.target.value)}
                placeholder="Links"
                className="w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm outline-none input_hover"
              />
            </div>
            <button
              type="button"
              onClick={() => handleRemoveLink(index)}
              className="p-2 text-gray-400 hover:text-gray-600"
              aria-label="Remove link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={1}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-trash w-[1rem] h-[1rem] text-[#808080]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 7l16 0" />
                <path d="M10 11l0 6" />
                <path d="M14 11l0 6" />
                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
              </svg>
            </button>
          </div>
        </div>
      ))}
      
      <button
        type="button"
        onClick={handleAddLink}
        className="px-0 py-1 text-sm font-semibold text-color"
      >
        + Add relevant link
      </button>
      {error && (
        <p className="mt-1 text-sm text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};

export default LinkInputComponent;